"use client";

import { ExternalLinkIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { ReactElement } from "react";

interface CardProps {
  heading: string;
  description: string;
  icon: ReactElement;
  href: string;
}

export const ApiCard = ({ heading, description, icon, href }: CardProps) => {
  return (
    <Box
      maxW={{ base: "full", md: "275px" }}
      w={"full"}
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p={5}
    >
      <Stack
        as={"a"}
        href={href}
        align={"start"}
        spacing={2}
        target={
          href && (href.startsWith("https") || href.startsWith("http"))
            ? "_blank"
            : ""
        }
      >
        <Flex
          w={16}
          h={16}
          align={"center"}
          justify={"center"}
          color={"white"}
          rounded={"full"}
          bg={useColorModeValue("gray.100", "gray.700")}
        >
          {icon}
        </Flex>
        <Box mt={2}>
          <Heading size="md">
            {heading}
            {href && (href.startsWith("https") || href.startsWith("http")) && (
              <>
                &nbsp; <ExternalLinkIcon />
              </>
            )}
          </Heading>
          <Text mt={1} fontSize={"sm"}>
            {description}
          </Text>
        </Box>
        <Button variant={"link"} colorScheme={"black"} size={"sm"}>
          Learn more
        </Button>
      </Stack>
    </Box>
  );
};
